import { Input } from "@/components/ui/input";

interface SettingLimitInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
}

/**
 * Number input for a setting limit: empty means unlimited, otherwise a positive whole number.
 * @param props - SettingLimitInputProps
 * @returns Limit input element
 */
export function SettingLimitInput({
  value,
  onChange,
  disabled,
}: SettingLimitInputProps) {
  /**
   * Applies the typed value, ignoring anything that is not a positive whole number.
   * @param raw - The input's raw string value
   */
  const handleChange = (raw: string) => {
    if (raw === "") {
      onChange(null);
      return;
    }
    const parsed = Number(raw);
    if (!Number.isInteger(parsed) || parsed < 1) {
      return;
    }
    onChange(parsed);
  };

  return (
    <Input
      type="number"
      inputMode="numeric"
      min={1}
      step={1}
      placeholder="Unlimited"
      value={value ?? ""}
      onChange={(e) => handleChange(e.target.value)}
      disabled={disabled}
      className="w-28"
    />
  );
}
